import { AlertTriangle, Heart, MapPin, CheckCircle2 } from 'lucide-react';
import { useTheme, colorSchemes } from '@/context/ThemeContext';

export const StatsBanner = ({ stats }) => {
  const { colorScheme } = useTheme();
  const theme = colorSchemes[colorScheme];
  const c1 = theme.gradientFrom;
  const c2 = theme.gradientTo;

  const items = [
    { label: 'Needs', value: stats.active_needs, icon: AlertTriangle },
    { label: 'Offers', value: stats.active_offers, icon: Heart },
    { label: 'Resources', value: stats.total_resources, icon: MapPin },
    { label: 'Resolved', value: stats.resolved, icon: CheckCircle2 },
  ];

  return (
    <div className="grid grid-cols-4 gap-2" data-testid="crisis-stats">
      {items.map((s, i) => {
        const Icon = s.icon;
        const numStr = s.value?.toLocaleString?.() || String(s.value);
        const fontSize = numStr.length > 4 ? 'text-base' : 'text-2xl';
        const color = i % 2 === 0 ? c1 : c2;
        return (
          <div key={s.label}
            className="relative overflow-hidden rounded-xl p-3 text-center transition-all hover:scale-[1.03]"
            style={{
              background: `${color}12`,
              border: `1px solid ${color}40`,
              boxShadow: `0 0 20px ${color}18`,
            }}
          >
            <div className="absolute -top-3 -right-3 w-12 h-12 rounded-full blur-xl opacity-40" style={{ background: color }} />
            <div className="relative">
              <div className="flex items-center justify-center mb-1">
                <div className="w-7 h-7 rounded-full flex items-center justify-center" style={{ background: `${color}20`, boxShadow: `0 0 0 3px ${color}30` }}>
                  <Icon className="w-3.5 h-3.5" style={{ color }} />
                </div>
              </div>
              <p className={`${fontSize} font-black tabular-nums tracking-tight leading-none`} style={{ color }}>{numStr}</p>
              <p className="text-[9px] uppercase tracking-[0.15em] font-semibold mt-1 text-muted-foreground">{s.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
